import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

export function UpdateAlertIcon(): JSX.Element {
    const tootipText = 'This event has been updated recently. View the event to find out more.';
    return <FiAlertCircle title={tootipText} className="ffncc-update-alert-icon" />;
}
